import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Phone, ClipboardCheck, Navigation, PackageCheck } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

const icons = [Phone, ClipboardCheck, Navigation, PackageCheck];

export function Timeline() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="metodo" data-testid="timeline-section" className="relative bg-asphalt py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <Overline>{t.timeline.overline}</Overline>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-ice sm:text-4xl lg:text-5xl">
            {t.timeline.title}
          </h2>
        </Reveal>

        <div ref={ref} className="relative mt-14">
          {/* Desktop horizontal route */}
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-edge lg:block">
            <motion.div style={{ scaleX }} className="h-px w-full origin-left bg-amber" />
          </div>
          {/* Mobile vertical route */}
          <div className="absolute bottom-0 left-[27px] top-7 w-px bg-edge lg:hidden">
            <motion.div style={{ scaleY }} className="h-full w-px origin-top bg-amber" />
          </div>

          <div className="grid grid-cols-1 gap-10 lg:grid-cols-4 lg:gap-6">
            {t.timeline.steps.map((step, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={step.n} delay={i * 0.1} className="relative flex gap-5 lg:block">
                  <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-amber bg-carbon text-amber">
                    <Icon className="h-6 w-6" strokeWidth={1.8} />
                  </div>
                  <div className="lg:mt-6">
                    <span className="font-display text-sm font-bold text-amber">{step.n}</span>
                    <h3 className="mt-1 font-display text-lg font-bold text-ice">{step.t}</h3>
                    <p className="mt-2 max-w-xs text-sm leading-relaxed text-steel">{step.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
